// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar2_navbar__BKove","left":"Navbar2_left__Bh0FA","brand":"Navbar2_brand__o4uPC","user":"Navbar2_user__AdUjP","menuIcon":"Navbar2_menuIcon__jr02t"};